import React from 'react';
import { css, Global } from '@emotion/react';

// reset margin and padding for html tags, reset list style
// import 'antd/es/style/v2-compatible-reset';
import '../less/ant-override.less';
import theme from '../theme';

type BaseLayoutProps = {
  children: React.ReactNode;
  seoTitle?: string;
  style?: string;
};

export const GlobalStyle = (
  <Global
    styles={css`
      :root {
        body * {
          font-family: ${theme.fontFamily};
        }
      }

      html {
        scroll-padding-top: 125px;
      }

      html,
      body,
      #___gatsby {
        height: 100%;
      }

      body {
        margin: 0px;
        background-color: #ffffff;
      }

      div[role='group'][tabindex] {
        height: 100%;
      }

      ol,
      ul,
      dl {
        margin-top: 0;
        margin-bottom: 0;
      }
    `}
  />
);

export default function withBaseLayout(WrappedComponent: React.ComponentType<any>) {
  return function BaseLayout(props: BaseLayoutProps) {
    return <WrappedComponent {...props} />;
  };
}
